import { useParams } from 'react-router-dom';
import { Box, DropdownOptions, Flex, FormProvider, Spinner, TooltipPopup } from 'dash-ui';
import { useTranslation } from 'react-i18next';

import NotFoundPage from 'pages/flow/NotFoundPage/NotFoundPage';
import { useGetOrganizationByIdQuery } from 'gql/generated.graphql';
import { useBrowserTabTitle } from 'common/hooks/use-browser-tab-title/use-browser-tab-title';

import OrganizationDetailsHeader from './components/OrganizationDetailsHeader/OrganizationDetailsHeader';
import OrganizationDetailsTabs from './components/OrganizationDetailsTabs/OrganizationDetailsTabs';
import { SaveSaleFormFieldsList } from 'pages/external-sales/external-sale-teams/constants';

function OrganizationDetailsPage() {
  const { id } = useParams();
  const { t } = useTranslation();

  const { data, loading } = useGetOrganizationByIdQuery({
    variables: { organizationId: id },
  });
  const organization = data?.getOrganizationById || null;

  useBrowserTabTitle(
    `${organization ? organization?.name : 'Organizations'} ${t(
      'common:labels.dashSuffix'
    )}`
  );

  return (
    <Flex flexDirection="column" flex={1} w="100%">
      <DropdownOptions />
      <TooltipPopup />
      <Box w="100%" pos="relative">
        {loading ? (
          <Spinner size={32} fullContent />
        ) : organization ? (
          <>
            <OrganizationDetailsHeader organization={organization} />
            <FormProvider fieldsList={SaveSaleFormFieldsList}>
              <OrganizationDetailsTabs />
            </FormProvider>
          </>
        ) : (
          <Box h={100}>
            <NotFoundPage />
          </Box>
        )}
      </Box>
    </Flex>
  );
}

export default OrganizationDetailsPage;
